<template>
  <div class="NormCompute">
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="采集设备">
          <a-select style="min-width: 210px" mode="multiple" show-search allowClear v-model="searchForm.deviceType" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in searchList" :key="item.id">
              <span v-for="name in equipmentList" :key="name.id">
                <span v-if="(name.id | item.id) == item.id">{{ name.name + '  ' }}</span>
              </span>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="计算状态">
          <a-select class="serach-item" show-search allowClear v-model="searchForm.status" placeholder="请选择">
            <a-select-option :value="0">采集中</a-select-option>
            <a-select-option :value="1">审核中</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getList(1)" type="primary" html-type="button"> 查询 </a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="add()" icon="plus" type="primary">添加采集</a-button>
          <a-button :loading="rerunScoreLoading" @click="rerunScore" style="margin-left: 15px" icon="diff" type="primary">重算粗分</a-button>
          <a-button :loading="updateContentLoading" @click="UpdateContentOriginalScore" style="margin-left: 15px" icon="diff" type="primary">重算原始分</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        row-key="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <div slot="name" slot-scope="text">
          {{
            equipmentList
              .filter((f) => (f.id | text.deviceType) === text.deviceType)
              .map((m) => m.name)
              .join(' ')
          }}
        </div>
        <div slot="sampleSize" slot-scope="text">
          {{ text.sampleSize }}
        </div>
        <div slot="dbqy" slot-scope="text">
          <span v-if="text.areaCharacteristicSize">
            {{ text.areaCharacteristicDescriptions != '[]' ? getDbqy(text.areaCharacteristicDescriptions) : '--' }}
          </span>
          <span v-else>--</span>
        </div>
        <div slot="applicationDevice" slot-scope="text">
          {{
            equipmentList
              .filter((f) => (f.id | text.deviceType) === text.deviceType)
              .map((m) => m.name)
              .join(' ')
          }}
        </div>
        <div slot="status" slot-scope="text">
          {{ text.status == 0 ? '采集中' : '审核中' }}
        </div>
        <div slot="action" slot-scope="text">
          <span v-if="text.status == 0">
            <a @click="edit(text)" style="margin-right: 8px; color: #1890ff">编辑</a>
            <a-popconfirm title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deleteitem(text)">
              <a style="color: #f00"> <a-icon type="delete" />删除 </a>
            </a-popconfirm>
            <!-- <a style="color: #f5222d;" @click="deleteitem(text)">删除</a> -->
          </span>

          <span v-else>
            <a @click="view(text)" style="margin-right: 8px; color: #1890ff">查看</a>
            <a @click="pass(text)" style="margin-right: 8px">通过</a>
            <a style="color: #f5222d" @click="reject(text)">拒绝</a>
          </span>
        </div>
      </a-table>
    </div>
    <!-- 通过 常模应用设置-->
    <a-modal :centered="true" v-model="appSet.visible" :title="appSet.title" :confirm-loading="appSet.confirmLoading" @ok="appSetOk" @cancel="appSetCancel" okText="应用并上线" width="600px">
      <a-form-model ref="appSetForm" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17 }" :model="appSet.data" :rules="appSet.rules">
        <a-form-model-item label="游戏名称" prop="contentName">
          <a-input v-model="appSet.data.contentName" disabled :maxLength="25" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="应用设备" prop="deviceType">
          <a-select show-search allowClear mode="multiple" v-model="appSet.data.deviceType" disabled placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否生效" prop="isTakeEffect">
          <a-radio-group v-model="appSet.data.isTakeEffect">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  { title: '常模名称', dataIndex: 'name' },
  { title: '采集设备', scopedSlots: { customRender: 'name' } },
  { title: '样本量', scopedSlots: { customRender: 'sampleSize' } },
  { title: '代表区域', scopedSlots: { customRender: 'dbqy' } },
  { title: '应用设备', scopedSlots: { customRender: 'applicationDevice' } },
  { title: '计算状态', scopedSlots: { customRender: 'status' } },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '创建时间', dataIndex: 'createTime' },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'NormCompute',
  data() {
    return {
      abilityInfo: this.$store.getters['content/getAbilityInfo'](),
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      // 重算粗分loading
      rerunScoreLoading: false,
      updateContentLoading: false,
      searchForm: {
        useOrCalculate: 0, //0 计算；1 应用
        deviceType: [],
        status: undefined,
        ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
      },
      searchList: [],
      searchData: [],
      equipmentList: [
        { id: 1, name: '其他' },
        { id: 2, name: '键盘' },
        { id: 4, name: '鼠标' },
        { id: 8, name: '触摸屏' },
        { id: 16, name: '全部' },
      ],
      appSet: {
        visible: false,
        title: '常模应用设置',
        confirmLoading: false,
        data: {
          id: '',
          contentName: sessionStorage.getItem('currentName'),
          deviceType: [],
          isTakeEffect: true,
          normName: undefined,
        },
        rules: {
          contentName: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
          deviceType: [{ required: true, message: '请选择应用设备', trigger: 'blur' }],
          isTakeEffect: [{ required: true, message: '请选择是否生效', trigger: 'blur' }],
        },
      },
    }
  },
  computed: {
    getDbqy() {
      return function (areaCharacteristicDescriptions) {
        try {
          const area = JSON.parse(areaCharacteristicDescriptions)
          return area
            .map((item) => {
              if (typeof item === 'string') {
                return item
              } else {
                return item.label
              }
            })
            .join(',')
        } catch (error) {
          return '--'
        }
      }
    },
  },
  mounted() {
    this.getList(1)
  },
  methods: {
    UpdateContentOriginalScore() {
      const form = new FormData()
      form.append('contentVersion', this.$route.query.version)
      form.append('contentId', this.$route.query.type === 'game' ? this.$store.getters['content/getEvaluationGameInfo']().id : this.$store.getters['content/getQuestionGroupInfo']().id)
      this.updateContentLoading = true
      this.$http.CourseCenter.UpdateContentOriginalScore(form).then((res) => {
        this.$message.success(res.message)
      }).finally(() => {
        this.updateContentLoading = false
      })
    },

    getList(pageIndex) {
      // this.searchList = []
      let params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.$http.NormSet.getList(params)
        .then((res) => {
          const { data } = res
          if (!this.searchForm.deviceType.length) {
            this.searchList = data.items
              .map((m) => ({ id: m.deviceType, name: '' }))
              .reduce((acc, current) => {
                const exists = acc.find((item) => item.id === current.id)
                if (!exists) {
                  acc.push(current)
                }
                return acc
              }, [])
          }
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = res.data.totalCount
          this.tableRelevant.tablePagination.current = res.data.pageIndex
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看
    view(text) {
      this.$store.commit('content/setNormInfo', { ...text, fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/NormSeting/NormComputeDetail',
        query: {
          id: this.abilityInfo.id,
          type: this.$route.query.type,
          version: this.$route.query.version,
          ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
          recordId: text.id,
        },
      })
    },
    // 通过
    pass(text) {
      this.appSet.data.deviceType = []
      let params = {
        id: text.id,
      }
      this.$http.NormSet.GetGameVersionNorm(params)
        .then((res) => {
          const { data } = res
          this.equipmentList.forEach((v) => {
            if ((v.id | data.deviceType) == data.deviceType) {
              this.appSet.data.deviceType.push(v.id)
            }
          })
          this.appSet.data.contentName = data.name + ' v' + data.version
          this.appSet.data.id = data.id
          this.appSet.data.parentId = text.parentId
          this.appSet.data.parentNormName = text.parentName
          this.appSet.visible = true
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 拒绝
    reject(text) {
      let formData = new FormData()
      formData.append('id', text.id)
      formData.append('status', 0)
      this.$http.NormSet.NormReject(formData)
        .then((res) => {
          this.$message.success(res.message)
          this.getList(1)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 删除
    deleteitem(text) {
      let formData = new FormData()
      formData.append('id', text.id)
      formData.append('deleted', true)
      this.$http.NormSet.NormDelete(formData)
        .then(() => {
          this.getList(1)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    appSetCancel() {
      this.appSet.visible = false
      this.$refs.appSetForm.resetFields()
    },
    appSetOk() {
      this.$refs.appSetForm.validate((valid) => {
        if (valid) {
          const callback = () => {
            let formData = new FormData()
            formData.append('id', this.appSet.data.id)
            formData.append('isTakeEffect', this.appSet.data.isTakeEffect)
            this.$http.NormSet.NormAudit(formData)
              .then((res) => {
                  this.appSet.visible = false
                  this.getList(1)

              })
              .catch((err) => {
                console.log(err)
              })
          }
          if (this.appSet.data.parentId) {
            this.$confirm({
              title: '提示',
              content: `审核通过后，${this.appSet.data.parentNormName}将会被覆盖`,
              onOk: () => callback(),
            })
          } else {
            callback()
          }
        } else {
        }
      })
    },

    // 添加采集
    add() {
      this.$store.commit('content/setNormInfo', { fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/NormSeting/NormComputeSet',
        query: {
          id: this.abilityInfo.id,
          type: this.$route.query.type,
          version: this.$route.query.version,
          abilityId: this.$route.query.abilityId,
          ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
          contentId: this.$route.query.contentId,
        },
      })
    },
    // 编辑
    edit(text) {
      this.$store.commit('content/setNormInfo', { ...text, fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/NormSeting/NormComputeSet',
        query: {
          id: this.abilityInfo.id,
          type: this.$route.query.type,
          version: this.$route.query.version,
          ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
          recordId: text.id,
          sampleSize: text.sampleSize,
          abilityId: this.$route.query.abilityId,
          contentId: this.$route.query.contentId,
        },
      })
    },

    // 重算粗分
    rerunScore() {
      const form = new FormData()
      form.append('contentVersion', this.$route.query.version)
      form.append('contentId', this.$route.query.type === 'game' ? this.$store.getters['content/getEvaluationGameInfo']().id : this.$store.getters['content/getQuestionGroupInfo']().id)
      this.rerunScoreLoading = true
      this.$http.CourseCenter.updateContentStandardScore(form).then((res) => {
        this.$message.success(res.message)
      }).finally(() => {
        this.rerunScoreLoading = false
      })
    },
  },
}
</script>

<style scoped></style>
